/* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import Hammer from "@egjs/hammerjs";
import { Direction } from "./constants";
import { GesturePropError } from "./Errors";
import DraggingGestureHandler from "./DraggingGestureHandler";
import { isnan } from "./utils";
var FlingGestureHandler = /*#__PURE__*/ function(DraggingGestureHandler) {
    "use strict";
    _inherits(FlingGestureHandler, DraggingGestureHandler);
    var _super = _create_super(FlingGestureHandler);
    function FlingGestureHandler() {
        _class_call_check(this, FlingGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(FlingGestureHandler, [
        {
            key: "name",
            get: function get() {
                return "swipe";
            }
        },
        {
            key: "NativeGestureClass",
            get: function get() {
                return Hammer.Swipe;
            }
        },
        {
            key: "onGestureActivated",
            value: function onGestureActivated(event) {
                this.sendEvent(_object_spread_props(_object_spread({}, event), {
                    eventType: Hammer.INPUT_MOVE,
                    isFinal: false,
                    isFirst: true
                }));
                this.isGestureRunning = false;
                this.hasGestureFailed = false;
                this.sendEvent(_object_spread_props(_object_spread({}, event), {
                    eventType: Hammer.INPUT_END,
                    isFinal: true
                }));
            }
        },
        {
            key: "onRawEvent",
            value: function onRawEvent(ev) {
                var _this = this;
                _get(_get_prototype_of(FlingGestureHandler.prototype), "onRawEvent", this).call(this, ev);
                if (this.hasGestureFailed) {
                    return;
                }
                // Hammer doesn't send a `cancel` event for taps.
                // Manually fail the event.
                if (ev.isFinal) {
                    setTimeout(function() {
                        if (_this.isGestureRunning) {
                            _this.cancelEvent(ev);
                        }
                    });
                } else if (!this.hasGestureFailed && !this.isGestureRunning) {
                    // Tap Gesture start event
                    var gesture = this.hammer.get(this.name);
                    // @ts-ignore FIXME(TS)
                    if (gesture.options.enable(gesture, ev)) {
                        this.onStart(ev);
                        this.sendEvent(ev);
                    }
                }
            }
        },
        {
            key: "getHammerConfig",
            value: function getHammerConfig() {
                return {
                    // @ts-ignore FIXME(TS)
                    pointers: this.config.numberOfPointers,
                    direction: this.getDirection()
                };
            }
        },
        {
            key: "getTargetDirections",
            value: function getTargetDirections(direction) {
                var directions = [];
                if (direction & Direction.RIGHT) {
                    directions.push(Hammer.DIRECTION_RIGHT);
                }
                if (direction & Direction.LEFT) {
                    directions.push(Hammer.DIRECTION_LEFT);
                }
                if (direction & Direction.UP) {
                    directions.push(Hammer.DIRECTION_UP);
                }
                if (direction & Direction.DOWN) {
                    directions.push(Hammer.DIRECTION_DOWN);
                }
                // const hammerDirection = directions.reduce((a, b) => a | b, 0);
                return directions;
            }
        },
        {
            key: "getDirection",
            value: function getDirection() {
                // @ts-ignore FIXME(TS)
                var direction = this.getConfig().direction;
                var directions = [];
                if (direction & Direction.RIGHT) {
                    directions.push(Hammer.DIRECTION_HORIZONTAL);
                }
                if (direction & Direction.LEFT) {
                    directions.push(Hammer.DIRECTION_HORIZONTAL);
                }
                if (direction & Direction.UP) {
                    directions.push(Hammer.DIRECTION_VERTICAL);
                }
                if (direction & Direction.DOWN) {
                    directions.push(Hammer.DIRECTION_VERTICAL);
                }
                directions = _to_consumable_array(new Set(directions));
                if (directions.length === 0) return Hammer.DIRECTION_NONE;
                if (directions.length === 1) return directions[0];
                return Hammer.DIRECTION_ALL;
            }
        },
        {
            key: "isGestureEnabledForEvent",
            value: function isGestureEnabledForEvent(param, _recognizer, param1) {
                var numberOfPointers = param.numberOfPointers, pointerLength = param1.maxPointers;
                var validPointerCount = pointerLength === numberOfPointers;
                if (!validPointerCount && this.isGestureRunning) {
                    return {
                        failed: true
                    };
                }
                return {
                    success: validPointerCount
                };
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_numberOfPointers = _param.numberOfPointers, numberOfPointers = _param_numberOfPointers === void 0 ? 1 : _param_numberOfPointers, direction = _param.direction, props = _object_without_properties(_param, [
                    "numberOfPointers",
                    "direction"
                ]);
                if (isnan(direction) || typeof direction !== "number") {
                    throw new GesturePropError("direction", direction, "number");
                }
                return _get(_get_prototype_of(FlingGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    numberOfPointers: numberOfPointers,
                    direction: direction
                }, props));
            }
        }
    ]);
    return FlingGestureHandler;
}(DraggingGestureHandler);
export default FlingGestureHandler;
